import { render, staticRenderFns } from "./CarreraImagen.vue?vue&type=template&id=0d08afd2&scoped=true&"
import script from "./CarreraImagen.vue?vue&type=script&lang=ts&"
export * from "./CarreraImagen.vue?vue&type=script&lang=ts&"
import style0 from "./CarreraImagen.vue?vue&type=style&index=0&id=0d08afd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08afd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VImg,VListItem,VListItemContent,VListItemTitle})
